import { set, setErrors } from '@/utils/vuex'

export default {
  setLoading: set('loading'),
  setErrors: setErrors(),
  setCountryCodes: set('countryCodes')
}
